function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var indexedDB = typeof window !== 'undefined' && (window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.OIndexedDB || window.msIndexedDB);
var isSupported = !!indexedDB;
var DB_NAME = 'uppy-blobs';
var STORE_NAME = 'files'; // maybe have a thumbnail store in the future

var DEFAULT_EXPIRY = 24 * 60 * 60 * 1000; // 24 hours

var DB_VERSION = 3; // Set default `expires` dates on existing stored blobs.

function migrateExpiration(store) {
  var request = store.openCursor();

  request.onsuccess = function (event) {
    var cursor = event.target.result;

    if (!cursor) {
      return;
    }

    var entry = cursor.value;
    entry.expires = Date.now() + DEFAULT_EXPIRY;
    cursor.update(entry);
  };
}

function connect(dbName) {
  var request = indexedDB.open(dbName, DB_VERSION);
  return new Promise(function (resolve, reject) {
    request.onupgradeneeded = function (event) {
      var db = event.target.result;
      var transaction = event.currentTarget.transaction;

      if (event.oldVersion < 2) {
        // Added in v2: DB structure changed to a single shared object store
        var store = db.createObjectStore(STORE_NAME, {
          keyPath: 'id'
        });
        store.createIndex('store', 'store', {
          unique: false
        });
      }

      if (event.oldVersion < 3) {
        // Added in v3
        var _store = transaction.objectStore(STORE_NAME);

        _store.createIndex('expires', 'expires', {
          unique: false
        });

        migrateExpiration(_store);
      }

      transaction.oncomplete = function () {
        resolve(db);
      };
    };

    request.onsuccess = function (event) {
      resolve(event.target.result);
    };

    request.onerror = reject;
  });
}

function waitForRequest(request) {
  return new Promise(function (resolve, reject) {
    request.onsuccess = function (event) {
      resolve(event.target.result);
    };

    request.onerror = reject;
  });
}

var cleanedUp = false;

var IndexedDBStore = /*#__PURE__*/function () {
  function IndexedDBStore(opts) {
    var _this = this;

    _classCallCheck(this, IndexedDBStore);

    this.opts = _objectSpread({
      dbName: DB_NAME,
      storeName: 'default',
      expires: DEFAULT_EXPIRY,
      // 24 hours
      maxFileSize: 10 * 1024 * 1024,
      // 10 MB
      maxTotalSize: 300 * 1024 * 1024
    }, opts);
    this.name = this.opts.storeName;

    var createConnection = function createConnection() {
      return connect(_this.opts.dbName);
    };

    if (!cleanedUp) {
      cleanedUp = true;
      this.ready = IndexedDBStore.cleanup().then(createConnection, createConnection);
    } else {
      this.ready = createConnection();
    }
  }

  _createClass(IndexedDBStore, [{
    key: "key",
    value: function key(fileID) {
      return "".concat(this.name, "!").concat(fileID);
    }
    /**
     * List all file blobs currently in the store.
     */

  }, {
    key: "list",
    value: function list() {
      var _this2 = this;

      return this.ready.then(function (db) {
        var transaction = db.transaction([STORE_NAME], 'readonly');
        var store = transaction.objectStore(STORE_NAME);
        var request = store.index('store').getAll(IDBKeyRange.only(_this2.name));
        return waitForRequest(request);
      }).then(function (files) {
        var result = {};
        files.forEach(function (file) {
          result[file.fileID] = file.data;
        });
        return result;
      });
    }
    /**
     * Get one file blob from the store.
     */

  }, {
    key: "get",
    value: function get(fileID) {
      var _this3 = this;

      return this.ready.then(function (db) {
        var transaction = db.transaction([STORE_NAME], 'readonly');
        var request = transaction.objectStore(STORE_NAME).get(_this3.key(fileID));
        return waitForRequest(request);
      }).then(function (result) {
        return {
          id: result.data.fileID,
          data: result.data.data
        };
      });
    }
    /**
     * Get the total size of all stored files.
     *
     * @private
     */

  }, {
    key: "getSize",
    value: function getSize() {
      var _this4 = this;

      return this.ready.then(function (db) {
        var transaction = db.transaction([STORE_NAME], 'readonly');
        var store = transaction.objectStore(STORE_NAME);
        var request = store.index('store').openCursor(IDBKeyRange.only(_this4.name));
        return new Promise(function (resolve, reject) {
          var size = 0;

          request.onsuccess = function (event) {
            var cursor = event.target.result;

            if (cursor) {
              size += cursor.value.data.size;
              cursor.continue();
            } else {
              resolve(size);
            }
          };

          request.onerror = function () {
            reject(new Error('Could not retrieve stored blobs size'));
          };
        });
      });
    }
    /**
     * Save a file in the store.
     */

  }, {
    key: "put",
    value: function put(file) {
      var _this5 = this;

      if (file.data.size > this.opts.maxFileSize) {
        return Promise.reject(new Error('File is too big to store.'));
      }

      return this.getSize().then(function (size) {
        if (size > _this5.opts.maxTotalSize) {
          return Promise.reject(new Error('No space left'));
        }

        return _this5.ready;
      }).then(function (db) {
        var transaction = db.transaction([STORE_NAME], 'readwrite');
        var request = transaction.objectStore(STORE_NAME).add({
          id: _this5.key(file.id),
          fileID: file.id,
          store: _this5.name,
          expires: Date.now() + _this5.opts.expires,
          data: file.data
        });
        return waitForRequest(request);
      });
    }
    /**
     * Delete a file blob from the store.
     */

  }, {
    key: "delete",
    value: function _delete(fileID) {
      var _this6 = this;

      return this.ready.then(function (db) {
        var transaction = db.transaction([STORE_NAME], 'readwrite');
        var request = transaction.objectStore(STORE_NAME).delete(_this6.key(fileID));
        return waitForRequest(request);
      });
    }
    /**
     * Delete all stored blobs that have an expiry date that is before Date.now().
     * This is a static method because it deletes expired blobs from _all_ Uppy instances.
     */

  }], [{
    key: "cleanup",
    value: function cleanup() {
      return connect(DB_NAME).then(function (db) {
        var transaction = db.transaction([STORE_NAME], 'readwrite');
        var store = transaction.objectStore(STORE_NAME);
        var request = store.index('expires').openCursor(IDBKeyRange.upperBound(Date.now()));
        return new Promise(function (resolve, reject) {
          request.onsuccess = function (event) {
            var cursor = event.target.result;

            if (cursor) {
              cursor.delete(); // Ignoring return value … it's not terrible if this goes wrong.

              cursor.continue();
            } else {
              resolve(db);
            }
          };

          request.onerror = reject;
        });
      }).then(function (db) {
        db.close();
      });
    }
  }]);

  return IndexedDBStore;
}();

IndexedDBStore.isSupported = isSupported;
export default IndexedDBStore;